<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="page_header">
		<h1 class="heading">Manage {{this.lblHeading}}</h1>
	</div>
	<div class="row">
		<div *ngIf="isRemove" class="text-danger col-md-12">
			<input type="hidden" [(ngModel)]="removeRef" name="id" /> <span [innerHTML]="deleteConfirm"></span>
			<button class="btn btn-danger btn-sm" (click)="onDelete(removeRef.id)" style="width:80px;">Yes</button>
			<button class="btn btn-default btn-sm" (click)="onNo()" style="width:80px;">No</button>
		</div>
		<div class="col-md-12" *ngIf="!isRemove">
			<table id="vTypes" class="table tbl-stl table-sm custom_table">
				<thead class="thead-inverse">
					<tr class="hd-clpse">
						<th class="tbl-hd-stl">
							ID
							<i style="vertical-align:middle; " class="fa"
								[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagID == 2),'fa-sort-desc sort-d': (utility.flags.flagID == 3), 'fa-sort':(utility.flags.flagID == 1) }"
								(click)="utility.onSort(0)"></i>
						</th>
						<th class="tbl-hd-stl">
							Code
							<i style="vertical-align:middle; " class="fa"
								[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagCE == 2),'fa-sort-desc sort-d': (utility.flags.flagCE == 3), 'fa-sort':(utility.flags.flagCE == 1) }"
								(click)="utility.onSort(1)"></i>
						</th>
						<th class="tbl-hd-stl">
							Description
							<i style="vertical-align:middle;" class="fa"
								[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagDN == 2),'fa-sort-desc sort-d': (utility.flags.flagDN == 3), 'fa-sort':(utility.flags.flagDN == 1) }"
								(click)="utility.onSort(2)"></i>
						</th>
						<th style="vertical-align:middle;" class="tbl-hd-stl">
							Status Use Indicator
						</th>
						<th style="vertical-align:middle;" class="tbl-hd-stl">
							Active?
							<i style="vertical-align:middle;" class="fa"
								[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagAE == 2),'fa-sort-desc sort-d': (utility.flags.flagAE == 3), 'fa-sort':(utility.flags.flagAE == 1) }"
								(click)="utility.onSort(3)"></i>
						</th>
						<th style="vertical-align:middle;" class="tbl-hd-stl">
							Sort Order
							<i style="vertical-align:middle;" class="fa"
								[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagSO == 2),'fa-sort-desc sort-d': (utility.flags.flagSO == 3), 'fa-sort':(utility.flags.flagSO == 1) }"
								(click)="utility.onSort(5)"></i>
						</th>
						<th style="vertical-align:middle;" class="tbl-hd-stl">
							Group
							<i style="vertical-align:middle;" class="fa"
								[ngClass]="{'fa-sort-asc sort-a': (utility.flags.flagGC == 2),'fa-sort-desc sort-d': (utility.flags.flagGC == 3), 'fa-sort':(utility.flags.flagGC == 1) }"
								(click)="utility.onSort(4)"></i>
						</th>
						<th style="vertical-align:middle;" class="tbl-hd-stl">Display</th>

						<th class="btn-show hgt-btn tbl-hd-stl end-col">
							<a [routerLink]="['/status/add']" title="" style="width:180px; ">
								<span title="Add a New Permit Type" class=" btn-add btn btn-primary btn-sm"><i
										class="fa fa-plus fa-2x" aria-hidden="true"></i></span>
							</a>
						</th>
					</tr>
				</thead>
				<tr
					*ngFor="let status of statuses  | orderBy: utility.criteria : utility.direction | paginate: { itemsPerPage: showNum, currentPage: utility.page }">
					<td class="bfr-end-col">{{status.id}}</td>
					<td class="bfr-end-col">{{status.code}}</td>
					<td class="bfr-end-col">{{status.description}}</td>
					<td class="bfr-end-col">{{utility.showStatusIndicator(status.status_use_ind)}}</td>
					<td class="bfr-end-col">{{utility.isActive(status.is_active)}}</td>
					<td class="bfr-end-col">{{status.sort_order}}</td>
					<td class="bfr-end-col">{{status.group_code}}</td>
					<td class="bfr-end-col">{{utility.showDisplayIndicator(status.display_ind)}}</td>
					<td class="btn-show bfr-end-col text-center">
						<div class="actions_wrap">
							<a [routerLink]="['/status/edit',status.id]"><span title="Edit Status"
								class="btn btn-success btn-sm"><i class="fa fa-pencil fa-fw"></i></span></a>
							<span title="Delete Status" style="margin-left: 8px;" class="btn btn-danger btn-sm"
								(click)="onConfirm(status)"><i class="fa fa-trash-o fa-fw"></i></span>
						</div>
					</td>
				</tr>
				<tfoot>
					<tr *ngIf="statuses.length > 4" class="pagination_row">
						<td colspan="9" class="rm-brd">
							<div class="row">
								<div class="col-4">
									<div class="input-group mb-3 rm-brd"
										style="width:125px!important;height:30px!important;">
										<div class="input-group-prepend">
											<label class="input-group-text form-control-sm show-h" for="show-id"
												>Show:</label>
										</div>
										<select class="form-control form-control-sm show-h" id="show-id"
											[(ngModel)]="showNum">
											<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
											</option>
										</select>
									</div>
								</div>
								<div class="col-8 text-right">
									<pagination-controls (pageChange)="utility.page = $event"
										style="margin-left:0px!important;padding-left:0px!important;"></pagination-controls>
								</div>
							</div>
						</td>

					</tr>
					<tr *ngIf="isEmpty">
						<td colspan="4" class="rm-brd">
							<span class="text-info text-small">No statuses found.</span>
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</div>